import React from 'react';
import UseContext from "hooks/useContext";

const Modalstructure = ({isShowing, children}) => {
    const { modalType } = UseContext();
    
    // Modales de validation d'identité qui nécessitent la largeur étendue
    const wideModals = [
        'ad_file_accept_identity',
        'ad_file_accept_visa',
        'ad_file_accept_simple',
        'ad_file_accept_card_vitality',
        'ad_file_visa_complementary',
        'ad_file_refuse',
        'ad_file_view',
        // A scanned mail or a PDF: readable only at the identity modals' width.
        'company_activity_justificatif'
    ];
    
    // Sized to the window rather than to its content: a document is read by
    // scrolling inside the modal, not by scrolling the page behind it.
    const fullSizeModals = ['contract_preview'];

    const isFullSize = fullSizeModals.includes(modalType);
    const isWideModal = wideModals.includes(modalType);
    const maxWidthClass = isFullSize
        ? 'max-w-[90vw]'
        : isWideModal
            ? 'max-w-[1400px]'
            : 'max-w-2xl';

    // The box never outgrows the window (100vh minus the 10vh top margin, the
    // 1rem bottom margin and the overlay's 2 × 1rem padding): ModalBody, the
    // only child allowed to shrink, scrolls while header and footer stay in
    // view. A modal that wraps its parts in a block the body cannot shrink
    // inside makes the box itself scroll, so nothing is ever cut off.
    const boxSizeClass = isFullSize
        ? 'h-full min-h-0'
        : 'max-h-[calc(90vh-3rem)] min-h-0 overflow-y-auto';

    return (
        <>
            {isShowing ?
                <>

                    <div className={`flex fixed justify-center inset-0 z-50 outline-none focus:outline-none p-4 ${isFullSize ? 'items-center overflow-hidden' : 'items-start overflow-y-auto'}`}>
                        <div className={`relative w-full ${maxWidthClass} mx-auto flex justify-center ${isFullSize ? 'h-[90vh]' : 'mt-[10vh] mb-4'}`}>
                            <div
                                data-testid="modal-box"
                                className={`relative flex flex-col w-full ${maxWidthClass} ${boxSizeClass} rounded-xl border border-gray-100 shadow-xl bg-white outline-none focus:outline-none`}>
                                {children}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-gray-900"></div>
                </> : null}
        </>
    );
};

export default Modalstructure;